export default __webpack_public_path__ + "static/NoelOffre-c998cf1f5dafc5d5cdd7849a7c170963.jpg";